import { customerApiEndpoints } from '@/api/endpoints';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import { Button, Form, Input, Modal, Space } from 'antd';
import { passwordValidation } from '@/utils/password';

const ChangePasswordModal = ({
  open,
  loading,
  onCancel,
  onFinish,
  selectedUserId,
  username,
  resetApi = customerApiEndpoints.resetUserPassword,
}) => {
  const [form] = Form.useForm();

  const submitForm = async () => {
    const data = form.getFieldsValue();

    await resetApi(selectedUserId, data);
    showToast('password changed successfully', 'success');
    onCancel();
    form.resetFields();
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      closable={false}
      autoFocus={true}
      width={450}
      footer={null}
      centered
    >
      <LoadingOverlay loading={loading} />
      <Form
        layout="vertical"
        form={form}
        onFinish={submitForm}
        autoComplete="off"
      >
        <GlobalDivider orientation="center" name="Change Password" />

        <Form.Item
          className="username"
          label="Enter new password"
          name="newPassword"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                return passwordValidation(value, username);
              },
            },
          ]}
        >
          <Input.Password type="password" />
        </Form.Item>

        <Form.Item
          className="username"
          label="Re-enter new password"
          name="confirmNewPassword"
          dependencies={['newPassword']}
          rules={[
            {
              required: true,
              validator: (_, value) => {
                if (value !== form.getFieldValue('newPassword')) {
                  return Promise.reject('The passwords do not match.');
                }
                return passwordValidation(value, username);
              },
            },
          ]}
        >
          <Input.Password type="password" />
        </Form.Item>

        <div style={{ textAlign: 'right' }}>
          <Space size="large">
            <Button
              className="submit-button"
              htmlType="submit"
              loading={loading}
            >
              Save
            </Button>

            <Button className="cancel-button" onClick={onCancel}>
              Cancel
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
